import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { ActivityIndicator } from "react-native";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import TicketsList from "@ticketingplatform/ui/dist/components/molecules/TicketsList";
import { useEventOccurrence } from "views/EventDetails/hooks";
import { Card, Flex } from "components/styles";
import environment from "setup/environment";
import { useOrderContext } from "providers/OrderProvider/hooks";
import { SCREENS } from "navigation/consts";
import ButtonLink from "components/atoms/ButtonLink";
import OrderSessionButton from "components/atoms/OrderSessionButton";
import useOrderSession from "hooks/useOrderSession";

import { useEventTickets } from "./hooks";
import * as Styled from "./styles";

const Cart: React.FC = () => {
  const intl = useIntl();
  const { eventOccurrence, loading } = useEventOccurrence(true);
  const { order, error } = useOrderContext();
  const eventTickets = useEventTickets();
  const { expireAt, expireIn, isExpired, onReset } = useOrderSession();

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!eventOccurrence) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Event not found" />
      </Text>
    );
  }

  return (
    <Flex padding="0.5rem" flexDirection="column" height="100%" overflow="auto">
      <Card>
        <Styled.Heading>
          <FormattedMessage defaultMessage="SELL TICKET(S)" />
        </Styled.Heading>
        <Styled.Total>
          <FormattedNumber
            style="currency"
            currency={environment.CURRENCY}
            value={order?.totalAmount || 0}
          />
        </Styled.Total>
        <TicketsList
          variant="secondary"
          onSaleLabel={intl.formatMessage({
            defaultMessage: "On Sale",
            description: "On Sale label",
          })}
          {...eventTickets}
        />
        <Styled.Actions>
          <ButtonLink
            $fullW
            to={{ screen: SCREENS.Billing }}
            type="button"
            $mode="tertiary"
            size="large"
            disabled={!order?.tickets?.nodes.length || isExpired}
          >
            <FormattedMessage defaultMessage="Next" />
          </ButtonLink>
          {expireAt && (
            <OrderSessionButton
              {...{
                expireIn,
                isExpired,
                onReset,
              }}
            />
          )}
          {error && <Styled.Error>{error.message}</Styled.Error>}
        </Styled.Actions>
      </Card>
    </Flex>
  );
};

export default Cart;
